const EVENTS = {
  FIELD: {
    INIT: 'Add Field Initialized',
    DELETED: 'Field Deleted',
    CREATED: 'Field Created',
  },
  CROP: {
    INIT: 'Add Crop Initialized',
    ADDED: 'Crop Added',
    DELETED: 'Crop Deleted',
    PRICE_UPDATED: 'Crop Price Updated',
  },
  STORAGE: {
    INIT: 'Add Storage Initialized',
    ADDED: 'Storage Added',
  },
  ACTIVITY: {
    INIT: 'Add Activity Initialized',
    SELECTED: 'Add Activity Selected',
    LOGGED: 'Activity Logged',
  },
  ACCOUNT: {
    LOGIN: 'Login Completed',
    REGISTER: 'Account Created',
  },
  CONTRACT: {
    ADDED: 'Contract Added',
  },
  YIELD: {
    NEW_YIELD_LOGGED: 'New Yield Logged',
  },
  SHARE: {
    SELECTED: 'Share Channel Selected',
  },
};

const PROPERTIES = {
  ACCOUNT: {
    LAST_LOGIN: 'Last Login Date',
    FIRST_LOGIN: 'First Login Date',
    CREATION_DATE: 'Account Creation Date',
    FARM_SIZE: 'Farm Size',
    FARM_ADDRESS: 'Farm Address',
    CROPS_ADDED: 'Crops Added',
  },
  CONTRACT: {
    DATE: 'Contract Date',
    DUE_DATE: 'Delivery Due Date',
    CONTRACTS_ADDED: 'Contracts Added',
  },
  CROP: {
    VARIETY: 'Crop Variety',
    NAME: 'Crop Name',
    PLANTED_AREA: 'Planted Area',
    SEASON: 'Season',
    EXPECTED_YIELD: 'Expected Yield',
  },
  ACTIVITY: {
    TYPE: 'Activity Type',
    DATE_OF_ACTIVITY: 'Date Of Activity',
    SOURCE: 'Source',
    DESTINATION_STORAGE: 'Destination Storage',
    DESTINATION_CONTRACT: 'Destination Contract',
    DESTINATION_OTHER: 'Destination Other',
  },
  FIELD: {
    AREA_MAPPED: 'Area Mapped',
    LOGGED: 'Activities Logged',
    TYPE: 'Activity Type',
    SOURCE: 'Source',
    DESTINATION_STORAGE: 'Destination Storage',
    DESTINATION_CONTRACT: 'Destination Contract',
    DESTINATION_OTHER: 'Destination Other',
    DATE_OF_ACTIVITY: 'Date Of Activity',
    FIELD_SIZE: 'Field Size',
  },
  YIELD: {
    YIELD_CHANGE: 'Yield Change',
  },
  SHARE: {
    CHANNEL: 'Share Channel',
    TYPE: 'Type',
  },
  STORAGE: {
    STORAGES_ADDED: 'Storages Added',
  },
};

export { EVENTS, PROPERTIES };



// WEBPACK FOOTER //
// ./src/common/constants/analytics.js